/**
 * @file WebSocket Metric Attributes Builder
 * @description Provides utility functions to build metric attributes for WebSocket responses and broadcasts in OpenTelemetry.
 */

import { getEnvKey } from 'constants/envs';

/**
 * Builds attributes for WebSocket response metrics.
 *
 * @param {string} method - The WebSocket method name.
 * @param {string} status - The status of the WebSocket response.
 * @returns {Object} An object containing WebSocket response metric attributes.
 */
export const buildWsResponseMetricAttributes = (method, status) => {
    const env = getEnvKey();

    return {
        'ws.method': method,
        'ws.status': status,
        env,
        'host_name': window?.location?.hostname || 'unknown',
    };
};

/**
 * Builds attributes for WebSocket broadcast metrics.
 *
 * @param {string} name - The name of the WebSocket broadcast event.
 * @returns {Object} An object containing WebSocket broadcast metric attributes.
 */
export const buildWsBroadcastMetricAttributes = (name) => {
    const env = getEnvKey();

    return {
        'ws.broadcast.name': name,
        env,
        'host_name': window?.location?.hostname || 'unknown',
    };
};
